"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogMetadata;
(function (LogMetadata) {
    LogMetadata.EMPTY_METADATA = {
        service: "universe-log-no-metadata",
    };
    function getBestIdentifier(metadata) {
        let ident = metadata.service ? `${metadata.service}.` : metadata.project ? `${metadata.project}.` : "";
        ident += metadata.module ? `${metadata.module}.` : "";
        ident += metadata.library ? `[${metadata.library}].` : "";
        ident += metadata.name || "";
        if (!ident)
            ident = "universe-log-empty-id";
        return ident;
    }
    LogMetadata.getBestIdentifier = getBestIdentifier;
})(LogMetadata = exports.LogMetadata || (exports.LogMetadata = {}));
//# sourceMappingURL=LogMetadata.js.map